<template>
  <div class="container">
    <loading v-if="pageStatus === 'loading'"></loading>
    <CompanyNotFound v-else-if="pageStatus === 'error'"></CompanyNotFound>
    <CreateDateTime
      v-else
      :active-room="{ id: roomId }"
      :company="{ id: companyId }"
      :total-price="Currency({ price: price }, currency)"
      @create:reservation="sendReservation"
      @cancel:reservation="cancelReservation"
    ></CreateDateTime>
    <div class="u-text-align-center u-margin-top u-margin-bottom">
      <a target="_blank" href="https://rezzervasyon.com">
        <img src="@/assets/images/Logo.png" alt="" />
      </a>
      <p>{{ $t("appName") }}</p>
    </div>
  </div>
</template>

<script>
import CompanyNotFound from "@/components/Chat/CompanyNotFound.vue";
import CreateDateTime from "@/components/Chat/CreateDateTime.vue";
import CryptoJS from "@/helpers/crypto";
const crypto = new CryptoJS("rezzApp-Por21LdxMl3Jk");
import $api from "@/services/Api";
import Requests from "@/services/Requests";
import { Currency } from "gurhan/helpers/Currency";
function convertTimeToDate(date, time) {
  const newDate = date.replace("T00:00:00", `T${time}:00`);
  return newDate;
}
export default {
  components: {
    CompanyNotFound,
    CreateDateTime,
  },
  data() {
    return {
      pageStatus: "loading",
      roomId: this.$route.params.roomId,
      companyId: this.$route.params.companyId,
      customerId: this.$route.params.customerId,
      selectedServices: [],
      price: 0,
      packageId: null,
      currency: "",
    };
  },
  methods: {
    Currency,
    cancelReservation() {
      window.parent.postMessage("closeChat", "*");
    },
    GET_HASH() {
      this.pageStatus = "loading";
      try {
        const hashedToken = this.$route.query.token || null;
        if (hashedToken) {
          const data = JSON.parse(crypto.decrypto(hashedToken));
          $api.token = data.token;
          this.price = data.price;
          this.selectedServices = data.selectedServices;
          this.packageId = data.packageId;
          this.currency = data.currency;
        }
        this.pageStatus = "started";
      } catch (error) {
        console.log(error, "error", this.$route.query.token);

        this.pageStatus = "error";
      }
    },
    async sendReservation(reservationInfo, loading) {
      loading(true);
      const data = {
        customerId: this.customerId,
        roomId: this.roomId,
        companyId: this.companyId,
        companyServiceIds: this.selectedServices,
        reservationDate: reservationInfo.date.isoStringDate,
        reservationTime: convertTimeToDate(
          reservationInfo.date.isoStringDate,
          reservationInfo.time.calendarTime
        ),
        customerPackageId: this.packageId || null,
      };
      const response = await Requests.Reservation.Create(data);
      if (response.message === "OK") {
        this.reservation = { ...data, id: response.data };
        window.parent.postMessage("succeedReservation", "*");
        if (reservationInfo.paymentType === "OnlinePayment") {
          this.$router.push({
            name: "pay",
            params: {
              id: response.data,
            },
          });
        } else this.$router.push("/track/" + response.data);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("authMessages.somethingWentWrong"),
          variant: "danger",
          duration: 10000,
        });
      }
      //TODO
      loading(false);
    },
  },
  mounted() {
    this.GET_HASH();
  },
};
</script>

<style></style>
